<script setup lang="ts">
import { UiToaster } from '@platform/ui';
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';

// Everything under one workspace is rebuilt when the workspace changes: nothing a page remembers
// about the previous one — its role, its limits, its data — may carry over.
const route = useRoute();
const workspaceKey = computed(() => (typeof route.params['tenant'] === 'string' ? route.params['tenant'] : ''));
</script>

<template>
  <RouterView :key="workspaceKey" />
  <UiToaster />
</template>
